let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8r9Rb")).then(() => parcelRequire('b83BE'));